'use strict';

function fZoomer () {
    function fDestroyZoomed (oZoomed = null, oBackdrop = null) {
        if (!oZoomed) oZoomed = document.querySelector('.zoomer');
        if (!oBackdrop) oBackdrop = document.querySelector('.backdrop--zoomer');

        if (oZoomed) oZoomed.parentNode.removeChild(oZoomed);
        if (oBackdrop) oBackdrop.parentNode.removeChild(oBackdrop);
    }

    function fGetSourceDimensions (oSource) {
        let oSourceDimensions = {
            width: oSource.offsetWidth,
            height: oSource.offsetHeight,
            x: offset(oSource).left,
            y: offset(oSource).top
        }

        return oSourceDimensions;
    }
    
    function fAnimateZoomed (oSource, oZoomed, nZoomedDimensions, oBackdrop, oCloser) {
        const oTimeline = new TimelineMax();
        const oZoomedImage = oZoomed.querySelector('.zoomer__image');
        const oSourceDimensions = fGetSourceDimensions(oSource);
        let nTopOffset = (window.innerHeight - nZoomedDimensions[1]) / 2;

        if (window.innerHeight < nZoomedDimensions[1]) {
            nTopOffset = (window.innerHeight - ((90 / 100) * window.innerHeight)) / 2;
        }
        
        function fFixModal () {
            oZoomed.style.position = 'fixed';
            oZoomed.style.top = '5%';
            oZoomed.style.bottom = '5%';
            oZoomed.style.left = '50%';
            oZoomed.style.right = 'auto';
            oZoomed.style.transform = 'translateX(-50%)';
        }

        oTimeline.timeScale(2.7);
        oTimeline
        .set(oZoomed, {
            display: 'block',
            top: oSourceDimensions.y,
            left: oSourceDimensions.x,
            width: oSourceDimensions.width,
            height: oSourceDimensions.height,
        })
        .set(oZoomed, {
            maxWidth: nZoomedDimensions[0] < nZoomedDimensions[1] ? '90vw' : 'none',
            maxHeight: nZoomedDimensions[0] > nZoomedDimensions[1] ? '90vh' : 'none'
        })
        .to(oZoomed, 1, {
            autoAlpha: 1,
            ease: Quart.linear
        })
        .to(oZoomed, 1.2, {
            top: `${nTopOffset + window.pageYOffset}px`,
            height: (nZoomedDimensions[1] === 'auto') ? nZoomedDimensions[1] : `${nZoomedDimensions[1]}px`,
            left: 0,
            right: 0,
            margin: 'auto',
            width: (nZoomedDimensions[0] === 'auto') ? nZoomedDimensions[0] : `${nZoomedDimensions[0]}px`,
            onComplete: fFixModal
        }, '-=0.5')
        .to(oBackdrop, 2, {
            autoAlpha: 1
        }, '-=1')
        .to(oZoomedImage, 1.5, {
            autoAlpha: 1
        }, '-=1.7')
        .to(oCloser, 1, {
            autoAlpha: 1
        }, '-=1.5');
    }

    function fCreateBackdrop () {
        const oBackdrop = document.createElement('div');

        oBackdrop.setAttribute('class', 'backdrop backdrop--zoomer');

        return oBackdrop;
    }

    function fCreateZoomed (sUrl) {
        let oZoomed = document.createElement('div');

        oZoomed.setAttribute('class', 'zoomer');
        oZoomed.innerHTML = `
            <button class="zoomer__close js-zoomer-close">
                <svg class="zoomer__close__icon"><use xlink:href="#close"></use></svg>
            </button>
            <img class="zoomer__image" src=${sUrl} />
        `;

        return oZoomed;
    }

    function fConstructUrl (sUrlOrigin, bLandscape) {
        let sUrl;

        if (bLandscape) {
            sUrl = sUrlOrigin + `&width=${((90 / 100) * window.innerWidth)}`;
        } else {
            sUrl = sUrlOrigin + `&height=${((90 / 100) * window.innerHeight)}`;
        }

        return sUrl;
    }

    function fCalculateZoomedDimensions (bLandscape, nRatio) {
        const nWindowWidth = window.innerWidth;
        const nWindowHeight = window.innerHeight;
        let nZoomedWidth;
        let nZoomedHeight;

        if (bLandscape) {
            nZoomedWidth = ((90 / 100) * nWindowWidth);
            nZoomedHeight = (nZoomedWidth * nRatio[1]) / nRatio[0];
        } else {
            nZoomedHeight = ((90 / 100) * nWindowHeight);
            nZoomedWidth = (nZoomedHeight * nRatio[0]) / nRatio[1];
        }

        return [nZoomedWidth, nZoomedHeight];
    }

    function isElementLandscape (oElement) {
        return oElement.offsetWidth > oElement.offsetHeight;
    }

    function getAspectRatio (nWidth, nHeight) {
        const nDivisor = gcd(nWidth, nHeight);
      
        return [(nWidth / nDivisor), (nHeight / nDivisor)];
    }

    function gcd (a, b) {
        // https://github.com/ryanhefner/calculate-aspect-ratio/blob/master/src/index.js
        return b
          ? gcd(b, a % b)
          : a;
    };

    document.addEventListener('click', function (event) {
        const oSource = event.target.closest('.js-zoomer');
        
        if (oSource) {
            const sUrlOrigin = oSource.getAttribute('data-zoomer-url');
            const bLandscape = isElementLandscape(oSource);
            const nRatio = getAspectRatio(oSource.offsetWidth, oSource.offsetHeight);
            const sUrl = fConstructUrl(sUrlOrigin, bLandscape);
            const oZoomed = fCreateZoomed(sUrl);
            
            const nZoomedDimensions = fCalculateZoomedDimensions(bLandscape, nRatio);
            const oBackdrop = fCreateBackdrop();
            const oCloser = oZoomed.querySelector('.js-zoomer-close');
            
            // Add zoomed & backdrop to the DOM
            document.body.appendChild(oZoomed);
            document.body.appendChild(oBackdrop);

            // Animate it from the source
            fAnimateZoomed(oSource, oZoomed, nZoomedDimensions, oBackdrop, oCloser);

            // Close active zoomer when backdrop or closer is clicked
            oBackdrop.addEventListener('click', function () {
                fDestroyZoomed(oZoomed, oBackdrop);
            });

            oCloser.addEventListener('click', function () {
                fDestroyZoomed(oZoomed, oBackdrop);
            });
        }
    });

    // Close active zoomer when esc key is pressed 
    document.addEventListener('keydown', function (event) {
        if (event.keyCode === 27) {
            fDestroyZoomed();
        }
    });
}